import { Link } from '@tanstack/react-router'
import { Shell } from '../components/Shell.tsx'

export function AccessDeniedPage() {
  return (
    <Shell title="Access Denied">
      <div className="card center">
        <p>You don’t have permission to view this page.</p>
        <Link to="/" className="btn">Return home</Link>
      </div>
    </Shell>
  )
}
